import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { MessageSquare, Send, Loader2, CheckCircle2 } from 'lucide-react'
import { postForm } from '@/lib/api/client'

export function FeedbackPage() {
  const { t } = useTranslation()
  const [content, setContent] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async () => {
    if (!content.trim()) return
    setSubmitting(true)
    try {
      // Try to submit to backend; fall back to mock success
      try {
        await postForm('/system/feedback', { content })
      } catch {
        // Mock mode - just simulate success
        await new Promise(resolve => setTimeout(resolve, 500))
      }
      setSubmitted(true)
      setContent('')
      setTimeout(() => setSubmitted(false), 3000)
    } catch (err) {
      console.error('Failed to submit feedback:', err)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="space-y-4 max-w-2xl">
      <h2 className="text-xl font-semibold flex items-center gap-2">
        <MessageSquare className="h-5 w-5" />
        {t('settings.feedback.title')}
      </h2>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('settings.feedback.content')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="feedback">{t('settings.feedback.content')}</Label>
            <Textarea
              id="feedback"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder={t('common.inputPlaceholder')}
              rows={6}
              className="resize-none"
            />
          </div>
          {submitted && (
            <div className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-600 dark:bg-green-950/30 dark:text-green-400 flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4" />
              {t('common.success')}
            </div>
          )}
          <Button onClick={handleSubmit} disabled={submitting || !content.trim()} className="w-full">
            {submitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
            {t('settings.feedback.submit')}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
